<template>
	<ul class="flex flex-col gap-2">
		<li
			v-for="source in status.sourceStatuses.toSorted((a, b) =>
				a.sourceLabel?.localeCompare(b.sourceLabel),
			)"
			:key="source.sourceType"
			class="flex flex-col"
		>
			<div class="flex items-center gap-2">
				<DataSourceStatusIcon :status="source.status" />
				<span
					>{{ source.sourceLabel
					}}<span
						v-if="source.validationMessages.length === 1"
						class="text-red-500"
					>
						- {{ splitHdnValue(source.validationMessages[0]?.type)[1] }}</span
					></span
				>
			</div>

			<div
				v-if="source.validationMessages.length > 0"
				class="flex flex-col pl-7 text-red-500"
			>
				<span v-if="source.validationMessages.length === 1">
					{{ source.validationMessages[0]?.description }}
				</span>
				<ul
					v-else-if="source.validationMessages.length > 1"
					class="flex flex-col gap-2"
				>
					<li
						v-for="message in source.validationMessages"
						:key="message.id"
						class="flex flex-col"
					>
						<span>{{ splitHdnValue(message.type)[1] }}</span>
						<span>{{ message.description }}</span>
					</li>
				</ul>
			</div>
		</li>
	</ul>
</template>

<script setup lang="ts">
import type { DataRequestStatusWithValidation } from "@/composables/useDataRequestStatus";
import { splitHdnValue } from "@/helpers/hdnHelpers";
import type { DeepReadonly } from "vue";

defineProps<{
	status: DeepReadonly<DataRequestStatusWithValidation>;
}>();
</script>
